const AttendanceTracker = ({ records = [], title = "Attendance" }) => {
  return (
    <div className="attendance-card">
      <h3>{title}</h3>
      {records.length === 0 ? (
        <p className="muted">No attendance records yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Role</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <tr key={record.id}>
                <td>{record.date}</td>
                <td>{record.role}</td>
                <td>{record.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AttendanceTracker;
